import Products from "./Products";
import TitleBarMin from "@/components/elements/TitleBar/TitleBarMin";
const ProductsPage = () => {
  return (
    <>
      {/* <TitleBarMin title="Our Products"></TitleBarMin> */}
      <div>
        {/* For the gap below nav */}

      </div>
      <div  >
      <Products />
      </div>
    </>
  );
};

export default ProductsPage;
